/**
 * Share a challenge using Telegram's inline query
 * Opens the native chat picker with the challenge pre-loaded
 */
export function shareChallenge(challengeId: string): void {
  const tg = window.Telegram?.WebApp;

  // switchInlineQuery requires Mini App version 6.7+
  const version = parseFloat(tg?.version || "0");
  const hasInlineQuery = tg && typeof tg.switchInlineQuery === "function" && version >= 6.7;

  // Desktop platforms (macos, tdesktop, web) have a known bug with switchInlineQuery
  // https://github.com/overtake/TelegramSwift/issues/1161
  const platform = tg?.platform || "";
  const isDesktop = ["macos", "tdesktop", "web", "weba", "webk"].includes(platform);

  if (hasInlineQuery && !isDesktop) {
    // Mobile: use inline query for beautiful card sharing
    tg.switchInlineQuery!(challengeId, ["users", "groups", "channels"]);
  } else {
    // Desktop or older clients: use share URL fallback
    const shareUrl = `https://t.me/pollygramchikbot?startapp=join_${challengeId}`;
    if (tg) {
      tg.openTelegramLink(
        `https://t.me/share/url?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent("Join my challenge on Pollygram!")}`
      );
    } else {
      window.open(shareUrl, "_blank");
    }
  }
}
